import React from 'react'
import propTypes from 'prop-types'
import Navigation from '../..'
import NavigationDropdown from '../NavigationDropdown'
import Container from '@/component/Primitive/Container'
import SmartLink from '@/component/Primitive/SmartLink'
import Icon from '@/component/Primitive/Icon'
import Type from '@/component/Primitive/Type'
import styles from './EventNavigation.module.scss'
import cx from 'classnames'

const EventNavigation = ({
  baseUrl,
  baseUrls,
  eventNavItems,
  inverseHeader,
  mobileOnly,
  logos: { light },
  isEventPage,
  showLogoInNavigation,
  ctaButton,
  isEventLive
}) => {
  const retrieveUrl = (link) => {
    switch (link.type) {
      case 'label':
        return null
      case 'eventSection':
      case 'eventUmbrellaSection':
        if (!link.url) return baseUrl
        return `${baseUrl}${link.url}`
      case 'externalLink':
        return link.url
      default:
        break
    }
  }

  const retrieveCtaUrl = (cta) => {
    if (cta.eventLayoutSlug) {
      return `${baseUrl}/${cta.eventLayoutSlug}`
    } else if (cta.link) {
      return cta.link
    } else {
      return ''
    }
  }

  if (mobileOnly) {
    return (
      eventNavItems && (
        <>
          <div className={styles.LogoWrapper}>
            {isEventPage && !showLogoInNavigation && (
              <SmartLink
                as={baseUrls.eventUmbrella}
                to="/events"
                className={styles.BackLink}
              >
                <Type
                  as="p"
                  weight={['bold', 'medium']}
                  size={['body4', 'body3']}
                  className={cx(styles.Back)}
                >
                  <Icon
                    width={9}
                    height={12}
                    type="arrow-left"
                    a11yText="Back to event Portfolio"
                    className={styles.BackIcon}
                  />
                  Portfolio
                </Type>
              </SmartLink>
            )}
            {showLogoInNavigation && (
              <SmartLink
                as={baseUrl}
                to="/events"
                className={cx(styles.Logo, isEventPage && styles.event)}
              >
                <img alt="" src={light} />
              </SmartLink>
            )}
          </div>
          {eventNavItems.map((link, i) => (
            <Navigation.Item
              title={link.title}
              to={link.type.includes('event') ? '/events' : ''}
              as={retrieveUrl(link)}
              key={`event-${i}`}
              inverse={inverseHeader}
              classNames={{
                NavigationItemLink: styles.EventNavigationItemLink,
                Icon: styles.EventNavigationDropdownIcon
              }}
            >
              {!!link.subItems.length && (
                <NavigationDropdown
                  items={link.subItems.map((i) => {
                    // Hack to remove forward slash
                    if (i.type !== 'externalLink' && i.url)
                      i.url = i.url.replace('/', '')
                    return i
                  })}
                  baseUrl={baseUrl}
                />
              )}
            </Navigation.Item>
          ))}
          {ctaButton && (
            <Navigation.Item
              title={ctaButton.label}
              inverse={inverseHeader}
              id={ctaButton.buttonId}
              {...(ctaButton.link && {
                rel: 'noopener noreferrer',
                target: '_blank',
                href: ctaButton.link
              })}
              {...(ctaButton.eventLayoutSlug && {
                to: '/events',
                as: retrieveCtaUrl(ctaButton)
              })}
              classNames={{
                NavigationItemLink: cx(
                  styles.EventNavigationItemLink,
                  styles.cta,
                  ctaButton.buttonClassName
                )
              }}
            />
          )}
          {isEventPage && isEventLive && (
            <Navigation.Item
              title="LIVE"
              to="/events"
              as={`${baseUrl}/live`}
              inverse={inverseHeader}
              classNames={{
                NavigationItemLink: cx(
                  styles.EventNavigationItemLink,
                  styles.live
                )
              }}
            />
          )}
        </>
      )
    )
  }

  return (
    <div className={styles.EventNavigation}>
      <Container
        className={cx(
          styles.EventNavigationContainer,
          !showLogoInNavigation && styles.noLogo
        )}
        center
        size="wide"
      >
        {!isEventPage && showLogoInNavigation && (
          <SmartLink as={baseUrl} to="/events" className={cx(styles.Logo)}>
            <img alt="" src={light} />
          </SmartLink>
        )}
        {isEventPage && !showLogoInNavigation && (
          <SmartLink
            as={baseUrls.eventUmbrella}
            to="/events"
            className={styles.BackLink}
          >
            <Type
              as="p"
              weight={['bold', 'medium']}
              size={['body4', 'body3']}
              className={cx(styles.Back)}
            >
              <Icon
                width={9}
                height={12}
                type="arrow-left"
                a11yText="Back to event Portfolio"
                className={styles.BackIcon}
              />
              Back to Portfolio
            </Type>
          </SmartLink>
        )}
        {isEventPage && showLogoInNavigation && (
          <SmartLink
            as={baseUrl}
            to="/events"
            className={cx(styles.Logo, isEventPage && styles.event)}
          >
            <img alt="" src={light} />
          </SmartLink>
        )}
        <nav
          className={cx(
            styles.EventNavigationList,
            isEventPage && styles.event
          )}
        >
          {eventNavItems &&
            eventNavItems.map((link, i) => (
              <Navigation.Item
                title={link.title}
                to={link.type.includes('event') ? '/events' : ''}
                as={retrieveUrl(link)}
                {...(link.type === 'externalLink' && {
                  href: link.url,
                  target: '_blank',
                  rel: 'noopener noreferrer'
                })}
                key={`event-${i}`}
                inverse={inverseHeader}
                classNames={{
                  NavigationItemLink: styles.EventNavigationItemLink,
                  Icon: styles.EventNavigationDropdownIcon
                }}
              >
                {!!link.subItems.length && (
                  <NavigationDropdown
                    items={link.subItems.map((i) => {
                      // Hack to remove forward slash
                      if (i.type !== 'externalLink' && i.url)
                        i.url = i.url.replace('/', '')
                      return i
                    })}
                    baseUrl={i.type !== 'externalLink' && baseUrl}
                  />
                )}
              </Navigation.Item>
            ))}
          {ctaButton && (
            <Navigation.Item
              title={ctaButton.label}
              inverse={inverseHeader}
              id={ctaButton.buttonId}
              {...(ctaButton.link && {
                rel: 'noopener noreferrer',
                target: '_blank',
                href: ctaButton.link
              })}
              {...(ctaButton.eventLayoutSlug && {
                to: '/events',
                as: retrieveCtaUrl(ctaButton)
              })}
              classNames={{
                NavigationItemLink: cx(
                  styles.EventNavigationItemLink,
                  styles.cta,
                  ctaButton.buttonClassName
                )
              }}
            />
          )}
          {isEventPage && isEventLive && (
            <Navigation.Item
              title="LIVE"
              to="/events"
              as={`${baseUrl}/live`}
              inverse={inverseHeader}
              classNames={{
                NavigationItemLink: cx(
                  styles.EventNavigationItemLink,
                  styles.live
                )
              }}
            />
          )}
        </nav>
      </Container>
    </div>
  )
}

EventNavigation.propTypes = {
  baseUrl: propTypes.string,
  eventNavItems: propTypes.array,
  inverseHeader: propTypes.bool,
  mobileOnly: propTypes.bool,
  logos: propTypes.shape({
    light: propTypes.string,
    dark: propTypes.string
  }),
  isEventPage: propTypes.bool,
  baseUrls: propTypes.shape({
    eventUmbrella: propTypes.string,
    event: propTypes.string
  }),
  showLogoInNavigation: propTypes.bool,
  isEventLive: propTypes.bool,
  ctaButton: propTypes.shape({
    label: propTypes.string,
    buttonId: propTypes.string,
    buttonClassName: propTypes.string,
    link: propTypes.string,
    eventLayoutSlug: propTypes.string
  })
}

export default EventNavigation
